export default {
  init() {
    // JavaScript to be fired on all pages

    if ($("#header-countdown").length > 0) {
      // get value from data attribute in countdown element from message bar
      var countdownData = document
        .getElementById("header-countdown")
        .getAttribute("data-countdown");
      // Set the date we're counting down to
      var countDownDate = new Date(countdownData).getTime();

      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        document.getElementById("header-countdown").innerHTML =
          days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        // If the count down is finished, write some text
        // if (distance < 0) {
        //   clearInterval(x);
        //   document.getElementById("demo").innerHTML = "EXPIRED";
        // }
      }, 1000);
    }

    if ($("#modal-header-countdown").length > 0) {
      // get value from data attribute in countdown element from message bar
      var countdownData = document
        .getElementById("modal-header-countdown")
        .getAttribute("data-countdown");
      // Set the date we're counting down to
      var countDownDate = new Date(countdownData).getTime();

      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        document.getElementById("modal-header-countdown").innerHTML =
          "<ul><li>" +
          days +
          "<span>Days</span></li><li>" +
          hours +
          "<span>Hours</span></li><li>" +
          minutes +
          "<span>Minutes</span></li><li>" +
          seconds +
          "<span>Seconds</span></li></ul>";

        // If the count down is finished, write some text
        // if (distance < 0) {
        //   clearInterval(x);
        //   document.getElementById("demo").innerHTML = "EXPIRED";
        // }
      }, 1000);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // ROOF MAKER MODAL
    function getCookie(name) {
      var cookies = "; " + document.cookie;
      var splitCookie = cookies.split("; " + name + "=");
      if (splitCookie.length == 2) return splitCookie.pop();
    }

    if (sessionStorage.getItem("RM-MODAL")) {
      // Modal already shown in this session
    } else {
      setTimeout(function () {
        // Show modal after 3 seconds
        $("body").addClass("rm-modal-show");
      }, 3000);
    }

    $(".rm-modal i, .rm-modal-shade, .modal-timer-cta .btn").click(function () {
      console.log("modal close click");
      sessionStorage.setItem("RM-MODAL", "Modal Shown");
      
      $("body").removeClass("rm-modal-show");
    });

    if (
      $(
        ".product-gallery-nav-thumbnails,.reviews-slider,.other-products-slider,.product-gallery-main,.blind-gallery-main,.blind-gallery-nav-thumbnails,.blind-gallery-slider,.featured-blog-slider"
      ).length
    ) {
      // check is slick slider element on page before running the rest
      var $reviewStatus = $(".paging-info");
      var $slickElement = $(".reviews-slider");

      $slickElement.on(
        "init reInit afterChange",
        function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $reviewStatus.text(i + " of " + slick.slideCount);
        }
      );

      $slickElement.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        nextArrow: ".review-next",
        prevArrow: ".review-previous",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      // other products slider
      var $reviewStatus = $(".paging-info");
      var $slickElement = $(".other-products-slider");

      $slickElement.on(
        "init reInit afterChange",
        function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $reviewStatus.text(i + " of " + slick.slideCount);
        }
      );

      $slickElement.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        nextArrow: ".other-product-next",
        prevArrow: ".other-product-previous",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      // Product gallery
      $(".product-gallery-nav-thumbnails").slick({
        vertical: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: ".product-gallery-main",
        focusOnSelect: true,
        arrows: true,
        nextArrow: ".next-image",
        infinite: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              vertical: false,
              infinite: true,
              slidesToShow: 4,
            },
          },
        ],
      });

      $(".product-gallery-main").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".product-gallery-nav-thumbnails",
        arrows: false,
        infinite: true,
      });

      //Blind Gallery

      var blindGalleryMain = $(".blind-gallery-main");
      var numSlick = 0;
      blindGalleryMain.each(function () {
        numSlick++;
        $(this)
          .addClass("slider-" + numSlick)
          .slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: ".blind-gallery-nav-thumbnails.slider-" + numSlick,
            arrows: false,
            infinite: true,
          });
      });

      var blindGalleryNav = $(".blind-gallery-nav-thumbnails");
      var numSlickNav = 0;
      blindGalleryNav.each(function () {
        numSlickNav++;
        $(this)
          .addClass("slider-" + numSlickNav)
          .slick({
            dot: false,
            vertical: true,
            slidesToShow: 5,
            slidesToScroll: 2,
            asNavFor: ".blind-gallery-main.slider-" + numSlickNav,
            focusOnSelect: true,
            arrows: false,
            infinite: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  vertical: false,
                  infinite: true,
                  slidesToShow: 4,
                },
              },
            ],
          });
      });

      //Blind Gallery Slider
      $(".blind-gallery-slider").slick({
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        swipeToSlide: true,
        arrows: true,
        centerMode: true,
        centerPadding: "100px",
        responsive: [
          {
            breakpoint: 750,
            settings: {
              arrows: false,
              vertical: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              vertical: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              focusOnSelect: false,
            },
          },
        ],
      });
      //End Blind Gallery Slider

      //featured blog slider
      $(".featured-blog-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              slidesToShow: 1,
            },
          },
        ],
      });
    } // this is the end of the If statement to checked if there is .slick-slider element on the page

    if ($(".accordion-list").length) {
      $(".accordion-list > .accordion-item > .answer").hide();
      $(".accordion-list > .accordion-item.active > .answer").slideDown();

      $(".accordion-list > .accordion-item").click(function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active").find(".answer").slideUp();
        } else {
          $(".accordion-list > .accordion-item.active .answer").slideUp();
          $(".accordion-list > .accordion-item.active").removeClass("active");
          $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
      });

      $(".answer").click(function (e) {
        e.stopPropagation();
      });
    }

    $("a.search-trigger").click(function (event) {
      event.preventDefault();
      $(".header-search").toggleClass("visible");
    });

    $(".nav-primary-mobile .nav-level-1.has-level-2 a.nav-level-1-link").click(
      function (event) {
        event.preventDefault();
        $(this).next(".nav-level-2").toggleClass("show");
      }
    );

    $(".mobile-nav-trigger").click(function (event) {
      event.preventDefault();
      $(".nav-primary-mobile").toggleClass("open");
      var $trigger = $(this).toggleClass("open");
      $trigger.attr("aria-expanded", $trigger.hasClass("open"));
    });
  },
};

//smooth scroll anchor links
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 150,
          },
          1000,
          function () {
            // Callback after animation
            // Must change focus!
          }
        );
      }
    }
  });

function sliderWindow(sliderid) {
  $(sliderid).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: true,
  });

  $(sliderid).addClass("slider-reveal");
  $(".slider-shade").addClass("shade-reveal");
}

$(".slider-init").click(function () {
  var slider_window_id = $(this).attr("data-slider-init");
  sliderWindow(slider_window_id);
});

$(".slider-shade,.slide-close").click(function () {
  $(".slider-window").removeClass("slider-reveal");
  $(".slider-shade").removeClass("shade-reveal");
  $(".slider-window.slick-initialized").slick("unslick");
});

//show body after ready to prevent fouc
$(document).ready(function ($) {
  $("body").css("display", "block");

  if ($(".case-study-text-block iframe").length) {
    $(".single-case-studies iframe").wrap(
      '<div class="youtube-responsive-container" />'
    );
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all tab buttons and attach event listeners to them
  var tabButtons = document.getElementsByClassName("tablinks");
  for (var i = 0; i < tabButtons.length; i++) {
    tabButtons[i].addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default behavior of anchor links
      var categoryName = this.getAttribute("data-cat");
      var url = new URL(window.location.href);
      var currentCategory = url.searchParams.get("category");

      // Check if the clicked tab button corresponds to the current category
      if (currentCategory !== categoryName) {
        // Redirect to the base URL with the clicked category parameter
        url.pathname = window.location.pathname.includes("/blog")
          ? "/blog"
          : "/case-studies";
        url.searchParams.set("category", categoryName);
        window.location.href = url.href; // Redirect to the new URL
      }
    });
  }

  // Get the category parameter from the URL
  var urlParams = new URLSearchParams(window.location.search);
  var category = urlParams.get("category");

  // If no category parameter exists or it's "view-all", default to the first tab
  if (!category || category === "view-all") {
    category = document.querySelector(".tablinks").getAttribute("data-cat");
  }

  // Hide all tab contents
  var tabContents = document.getElementsByClassName("tabcontent");
  for (var i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }

  // If a category parameter exists in the URL, set the corresponding tab as active and show its content
  if (category) {
    var activeTab = document.querySelector(
      '.tab button[data-cat="' + category + '"]'
    );
    if (activeTab) {
      // Remove active class from all tab buttons
      var allTabButtons = document.querySelectorAll(".tab button");
      for (var i = 0; i < allTabButtons.length; i++) {
        allTabButtons[i].classList.remove("active");
      }

      activeTab.classList.add("active");

      // Show the corresponding tab content
      var tabContent = document.getElementById(category);
      if (tabContent) {
        tabContent.style.display = "block";
      }
    }
  }
});

// let currentPage = 1;
// $("#load-more").on("click", function (e) {
//   e.preventDefault();
//   currentPage++; // Do currentPage + 1, because we want to load the next page
//   let loadMoreCat = $(".load-more-btn").attr("data-slug");
//   console.log(loadMoreCat);
//   $.ajax({
//     type: "POST",
//     url: "/wp-admin/admin-ajax.php",
//     dataType: "html",
//     data: {
//       action: "roof_blog_load_more",
//       category: loadMoreCat,
//       paged: currentPage,
//     },
//     success: function (res) {
//       $(".publication-list").append(res);
//     },
//   });
// });

// //load new category
// let newCatPage =
//   parseInt(window.location.pathname.match(/\/page\/(\d+)\/?$/)[1]) || 1;
// $(".cat-list_item").on("click", function (e) {
//   e.preventDefault();
//   $(".publication-list").addClass("load-fade");
//   $(".cat-list_item").removeClass("active");
//   $(this).addClass("active");

//   let selectedCat = $(this).data("slug");

//   $.ajax({
//     type: "POST",
//     url: "/wp-admin/admin-ajax.php",
//     dataType: "html",
//     data: {
//       action: "load_new_blog_category",
//       category: selectedCat,
//       paged: newCatPage,
//     },
//     success: function (res) {
//       $(".publication-list").empty();
//       $(".publication-list").append(res);
//       currentPage = 1;
//       $("#load-more").attr("data-slug", selectedCat);
//       $(".publication-list").removeClass("load-fade");
//     },
//   });
// });



// WEBPACK FOOTER //
// ./scripts/routes/common.js